import React from 'react';
import classnames from 'classnames';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import EmployeeCell from '../../shared/tableCells/EmployeeCell';
import '../../shared/Table.css';

const Row = ({ employee, datesInWeek, schedules }) => {
  const formatDateForSchedulesKey = date => moment(date).format('YYYY-MM-DD');
  const getScheduleForDate = date => (schedules && schedules[formatDateForSchedulesKey(date)]) ? schedules[formatDateForSchedulesKey(date)] : [];

  return (
    <TableRow className='schedulingRow'>
      <EmployeeCell profileImage={employee.image} name={employee.name} />
      { datesInWeek.map((date, index) => {
        const schedule = getScheduleForDate(date);
        let totalBreakMinutes = 0;

        if (Array.isArray(schedule) && schedule.length > 0) {
          totalBreakMinutes = schedule.reduce((accumulator, currentValue) => {
            const { breakMinutes } = currentValue;

            return accumulator + parseInt(breakMinutes, 10);
          }, 0);
        }

        const tableCellClassnames = classnames({
          'flex-rows': true,
          'schedulingRowCell': true,
          'scheduleRowTimeCell': true,
          'shift-cell-today': moment(date).isSame(moment(), 'day')
        });

        return (
          <TableCell key={index} className={tableCellClassnames} align='center'>
            { totalBreakMinutes } minutes
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default Row;
